import { combineReducers } from 'redux';

import opinions from './reducer-opinions';
import opinionTypes from './reducer-opinion-types';
import selectedType from './reducer-selectedType';
import selectedStatus from './reducer-selectedStatus';
import selectedJurisdiction from './reducer-selectedJurisdiction';
import jurisdictions from './reducer-jurisdictions';
import pagination from './reducer-pagination';
import searchTerm from './reducer-searchTerm';
import opinionStats from './reducer-opinionsStats';
import loading from './loading_reducer';
export default combineReducers( {
	                                opinions,
	                                jurisdictions,
	                                opinionTypes,
	                                selectedType,
	                                selectedJurisdiction,
	                                selectedStatus,
	                                pagination,
	                                searchTerm,
	                                opinionStats,
	                                loading
                                } );
